var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMember360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.36 98.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.36,33.65v-14.21C140.52,9.01,132.3.38,121.89.01c-.05,0-.1-.01-.16-.01H18.63c-.05,0-.1.01-.16.01C8.06.38-.16,9.01,0,19.44v59.4c-.16,10.43,8.06,19.06,18.47,19.43.05,0,.11.01.16.01h103.11c.05,0,.11-.01.16-.01,10.41-.37,18.63-8.99,18.47-19.43v-19.31h0v-25.87h0Zm-67.64,0c.37-.83,1.18-1.42,2.15-1.44h39.57c1-.02,1.87.58,2.25,1.44.12.28.2.59.2.91.03,1.33-1.03,2.43-2.36,2.46h-39.57c-1.33.03-2.43-1.03-2.46-2.36,0-.36.07-.7.21-1.01Zm2.15,13.08h39.57c1.33-.03,2.43,1.03,2.46,2.36.03,1.33-1.03,2.43-2.36,2.46h-39.57c-1.33.03-2.43-1.03-2.46-2.36-.03-1.33,1.03-2.43,2.36-2.46Zm41.98,16.93c0,1.33-1.08,2.41-2.41,2.41h-39.48c-1.33,0-2.41-1.08-2.41-2.41s1.08-2.41,2.41-2.41h39.48c1.33,0,2.41,1.08,2.41,2.41ZM29.39,33.65c1.53-3.92,5.33-6.7,9.79-6.71h0c4.46,0,8.27,2.78,9.79,6.71.46,1.19.73,2.47.72,3.82,0,5.81-4.71,10.52-10.53,10.52-5.81,0-10.52-4.71-10.52-10.53,0-1.35.26-2.63.72-3.81Zm-5.98,30.11c0-14.2,31.56-14.2,31.56,0v5.26s-31.56,0-31.56,0v-5.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember360);
export default __webpack_public_path__ + "static/media/Member360.c3ea59066377d0b0e0100347e234ef80.svg";
export { ForwardRef as ReactComponent };